export const netflix = {
  name: 'Netflix',
  id: 'netflix',
  url: 'https://netflix.com/',
  color: 'black',
  compatible: true
}
